import Button from "primevue/button";
import Card from "primevue/card";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import MultiSelect from "primevue/multiselect";
import OverlayPanel from "primevue/overlaypanel";
import Fieldset from "primevue/fieldset";
import Slider from "primevue/slider";
import Dropdown from "primevue/dropdown";
import ProgressBar from "primevue/progressbar";
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import FloatLabel from "primevue/floatlabel";
import InputGroup from "primevue/inputgroup";
import Message from "primevue/message";
import Password from "primevue/password";
import ToggleButton from "primevue/togglebutton";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import Divider from "primevue/divider";

import VueWordCloud from "vuewordcloud";

import StepperButtons from "@/components/StepperButtons.vue";
import InputNumber from "primevue/inputnumber";

export default {
  Button,
  Card,
  DataTable,
  Column,
  Tag,
  MultiSelect,
  OverlayPanel,
  Fieldset,
  Slider,
  Dropdown,
  ProgressBar,
  Stepper,
  StepperPanel,
  InputText,
  FloatLabel,
  InputGroup,
  InputSwitch,
  Message,
  Password,
  ToggleButton,
  ColumnGroup,
  Row,
  Dialog,
  Checkbox,
  Textarea,
  InputNumber,
  VueWordCloud,
  StepperButtons,
  Divider,
};
